import { ListSelect } from '@/main/features/List/components/ListSelect/ListSelect'

export function MainIndex() {
  return (
    <>
      <div className="twc-flex twc-justify-between twc-items-center twc-mb-8">
        <div className="twc-prose prose-h2:mb-0 dark:twc-prose-invert">
          <h2 className="twc-font-medium">Projects</h2>
        </div>
      </div>

      <ListSelect className="twc-grid twc-grid-flow-row sm:twc-grid-cols-2 xl:twc-grid-cols-1 2xl:twc-grid-cols-2 twc-gap-4 twc-mb-6" />
    </>
  )
}
